var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 842,
    height: 117,
    viewBox: "0 0 842 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-24 123.5L868 134V99L542.5 94L323.5 66L-24 56V123.5Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M868 50.5L-24 31V56L323.5 66L542.5 94L868 99V50.5Z",
    fill: "#8575EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-30.5 45L494 83L849 109.5V34L-18.5886 27.7521C101.724 25.741 341.626 21.719 338.729 21.719C335.832 21.719 62.0896 17.5339 -74.4195 15.4414L-30.5 45Z",
    fill: "#EAB975"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1603 0L-88 3.92149L-74.4195 15.4414C62.0896 17.5339 335.832 21.719 338.729 21.719C341.626 21.719 101.724 25.741 -18.5886 27.7521L849 34V10.5L389.128 0L194 5.5L57.1603 0Z",
    fill: "#D4A16D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 374,
    y1: 113,
    x2: 374,
    y2: 59.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81CFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#879FD9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.dc997b917fc311db3c001f154aec537d.svg";
export { ForwardRef as ReactComponent };